export default __webpack_public_path__ + "static/media/bowie50.12bfed94.webp";